<rid-syllabic-keyboard-assignments
  class="h-dvh"
  name="Klankbord plus | klankvoeten"
  [layout]="{
    KLINKERS: 'DISABLED',
    LANGE_KLINKERS: 'DISABLED',
    KORTE_LANGE_KLINKERS: 'HIDDEN',
    SPACE: 'HIDDEN',
    DUBBELE_KLINKERS: 'DISABLED',
    DRIEDUBBELE_KLINKERS: 'DISABLED',
    VIERDUBBELE_KLINKERS: 'DISABLED',
    MEDEKLINKERS: 'DISABLED',
    EXOTEN: 'HIDDEN',
    SJWAS: 'DISABLED',
    KLANKVOET: 'ENABLED',
    RULE: 'DISABLED',
  }"
  [prompts]="prompts()"
  (finished)="finished.emit()"
/>
